export const Bio = {
  name: "Tarun Gupta",
  roles: [
    "Full Stack Developer",
    "MERN Stack Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Tarungupta18",
  resume:
    "https://drive.google.com/file/d/1kVQhhlKJovupBnBrkDQLZLRmSLVBj8ho/view?usp=drivesdk",
  linkedin: "https://www.linkdin.com/in/tarun-gupta-100a1b259",
  twitter: "",
  insta: "https://www.instagram.com/tarungupta_11/",
  facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/2048px-Typescript_logo_2020.svg.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind",
        image:
          "https://www.svgrepo.com/show/374118/tailwind.svg",
      },
      {
        name: "Material UI",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsL7a_rhUx0yrF7FRmTTHbjJOCHtbWRGSdXCaPatbl7A&s",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png",
      },
      {
        name: "Rest APIs",
        image: "https://www.iconpacks.net/icons/free-icons-6/free-rest-api-blue-logo-icon-22098-thumb.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "EJS",
        image:
          "https://www.svgrepo.com/show/373574/ejs.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "API",
        image: "https://cdn-icons-png.flaticon.com/512/627/627558.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Socket.io",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEsBOxoTrbdfcFix9XcbPt-qY1nKdudIDbfw&s",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "C",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/18/C_Programming_Language.svg",
      },
      {
        name: "C++",
        image:
          "https://play-lh.googleusercontent.com/RAA-PGAoUanS_aOu8qhDvQZ1d8jp_lhR_-zJrcvxpABgQtNQylCxNac_WvN-vVIz7Hw=w240-h480-rw",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "SQL",
        image: "https://www.svgrepo.com/show/331760/sql-database-generic.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Vercel",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSbnG-zUyHXa2wGRUdUYhjcIcLRfSUO_qR4g&s",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];


export const education = [
  {
    id: 0,
    img: "https://collegekhabri.com/data/shri-ram-institute-of-technology-logo.jpg",
    school: "Shri Ram Institute of Science & Technology, Jabalpur",
    date: "Oct 2021 - Sep 2025",
    grade: "8.39 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Shri Ram Institute of Science & Technology, Jabalpur. I have completed 6 semesters and have a CGPA of 8.39. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSCs0ySdpFl7hF37s4-2m5NJSrKAfvEWQAcKlCj0saLNFhaxS1TCBNJ85spZFsPjjJtdM&usqp=CAU",
    school: "Vidya Sagar Senior Sec. School, Burhar",
    date: "Apr 2020 - Apr 2021",
    grade: "85.6%",
    desc: "I completed my class 12 high school education at Vidya Sagar Senior Sec. School, Burhar, where I studied PCM - Physics, Chemistry, Math.",
    degree: "MPBOARD(XII), PCM",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSCs0ySdpFl7hF37s4-2m5NJSrKAfvEWQAcKlCj0saLNFhaxS1TCBNJ85spZFsPjjJtdM&usqp=CAU",
    school: "Vidya Sagar Senior Sec. School, Burhar",
    date: "Apr 2018 - Apr 2019",
    grade: "86.2%",
    desc: "I completed my class 10 education at Vidya Sagar Senior Sec. School, Burhar, where I studied Science, Math and  other subjects.",
    degree: "MPBOARD(X), Science & Computer",
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://github.com/Tarungupta18/upload-img/blob/aim/portfolio-img/workfall.jpg?raw=true",
    role: "Frontend Developer Intern",
    company: "Workfall PVT LTE",
    date: "July 2024 - Sept 2023",
    desc: "Build 10+ web pages from figma design.",
    skills: [
      "React",
      "Tailwind",
      "Responsive Design",
    ],
    doc: "https://drive.google.com/file/d/1YZHeK6VulKuzLInmDj2LS_EzLXNchbnU/view",
  },
  {
    id: 1,
    img: "https://github.com/Tarungupta18/upload-img/blob/aim/portfolio-img/cisco-icon.png?raw=true",
    role: "Virtual Cyber Security Intern",
    company: "Cisco Pvt. Ltd.",
    date: "Aug 2023 - June 2023",
    desc: "Working on Packet Tracer Platforms, creating College Network module/branch.",
    skills: [
      "Packet Flow",
      "Routers",
      "Packet Tracer",
    ],
    doc: "https://drive.google.com/file/d/14UmFFXe0veetA7Fvx7XkZ47wTyO_CdqA/view?usp=drivesdk",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/D560BAQEZKRKOWBcJ_A/company-logo_200_200/0/1706735138636/octanetsolutions_logo?e=2147483647&v=beta&t=x4pBgtyLAr0gBAUCImcbOCCmhOTWB8B8dkXMSA5lde0",
    role: "Web Developer Intern",
    company: "Octanet pvt. ltd.",
    date: "Feb 2024 - March 2024",
    desc: "Working on the frontend of the web application.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://drive.google.com/file/d/1m0PlqoxZd1CkcTcdNHyu-E7-qOW28N6l/view?usp=drivesdk",
  },
];


export const projects = [
  {
    id: 1,
    title: "AI Interview mocker",
    date: "June 2024 - June 2024",
    description:
      "An AI-powered mock interview platform that generates interview questions based on user input, allows users to record and analyze their answers with speech-to-text, and includes payment processing features for premium services.",
    image:
      "https://github.com/Tarungupta18/upload-img/blob/aim/portfolio-img/Screenshot%20(79).png?raw=true",
    tags: [
      "Next Js",
      "React",
      "Tailwind CSS",
      "PostgreSQL",
      "Drizzle ORM",
      "Gemini API",
    ],
    category: "web app",
    github: "https://github.com/Tarungupta18/AI-Interview-mocker",
    webapp: "https://ai-interview-mocker-chi.vercel.app/",
  },
  {
    id: 11,
    title: "SteamMeet",
    date: "July 2024 - July 2024",
    description:
      "A real-time video conferencing app that allows users to host video calls, send live messages, share their screens, and manage meeting settings such as muting participants and creating secure meeting rooms.",
    image:
      "https://github.com/Tarungupta18/upload-img/blob/aim/portfolio-img/Screenshot%20(94).png?raw=true",
    tags: [
      "React",
      "Node Js",
      "Express Js",
      "MongoDB",
      "Socket.io",
    ],
    category: "web app",
    github: "https://github.com/Tarungupta18/StreamMeet",
    webapp: "https://stream-meet-delta.vercel.app/",
  },
  {
    id: 11,
    title: "StayFinder",
    date: "Jan 2024 - Jan 2024",
    description:
      "An online marketplace for finding accommodations, where users can search for properties using geo-location, view multimedia content, and securely sign up or log in to access personalized features.",
    image:
      "https://github.com/Tarungupta18/upload-img/blob/aim/portfolio-img/Screenshot%20(78).png?raw=true",
    tags: [
      "React",
      "Node Js",
      "Express Js",
      "MongoDB",
      "Cloudinary",
      "JWT-Auth",
    ],
    category: "web app",
    github: "https://github.com/Tarungupta18/StayFinder",
    webapp: "https://stay-finder-five.vercel.app/",
  },
  {
    id: 9,
    title: "Weather-App",
    date: "Jan 2024 - Jan 2024",
    description:
      "We implemented a Material UI (React Framework) project weather display site. we uses a weather api for real time date sharing and displaying in a card with relatable image.",
    image:
      "https://github.com/Tarungupta18/upload-img/blob/aim/portfolio-img/weather-app.png?raw=true",
    tags: [
      "Html",
      "CSS",
      "JavaScript",
      "React Js",
      "Material UI",
      "Weather-API",
    ],
    category: "web app",
    github: "https://github.com/Tarungupta18/Weather-App.git",
    webapp: "https://weather-app-ko7s.onrender.com",
  },
];

